import { autoinject, InlineViewStrategy } from 'aurelia-framework';
import { bindable } from 'aurelia-templating';

import { FormModel } from '~/models/form-model';

@autoinject
export class NonCustomisableArea {
	@bindable public formModel: FormModel;
	@bindable public areaHtml: string;

	private viewStrategy?: InlineViewStrategy;

	private bind(bindingContext, overrideContext) {
		this.viewStrategy = new InlineViewStrategy(this.areaHtml);
	}
}
